import { createSelector } from 'reselect';
import { careerAndSeasonStatsSelector } from './simple-selectors';

export const careerAndSeasonStatsBenchmarkingSelector = createSelector(
    careerAndSeasonStatsSelector,
    careerAndSeasonStats => careerAndSeasonStats.benchmarking
);